
let oneRebuyUpsellWidgetAlreadyShown = false;
// Remove modal visible class when a "rebuy.show" event occurs
document.addEventListener('rebuy.show', () => {
    document.body.classList.remove('rebuy-modal-visible');
});

// Listen for  "rebuy:cart.add" event, this happens when a product is added NOT coming from a rebuy widget
document.addEventListener('rebuy:cart.add', (event) => {
    // For cart.add, the items array lives in event.detail.item.items
    const items = event.detail.item.items ? event.detail.item.items : [event.detail.item];
    const flags = { hasSubscription: false, hasOneTime: false, hasEkit: false };

    items.forEach((item) => {
        // If the item has a selling plan allocation, consider it a subscription
        if (item.selling_plan_allocation) {
            flags.hasSubscription = true;
        } else {
            flags.hasOneTime = true;
        }
        // Check for the specific ekit variant ID
        if (item.variant_id === 31782670336058) {
            flags.hasEkit = true;
        }
    });

    updateWidgets(flags);
});

/**
 * Updates widget visibility based on the provided flags.
 * @param {Object} flags - An object with booleans: hasSubscription, hasOneTime, hasEkit.
 */
function updateWidgets({ hasSubscription, hasOneTime, hasEkit }) {
    // If a widget has already been shown, exit early.
    if (oneRebuyUpsellWidgetAlreadyShown) return;
    // Toggle subscription widgets
    document.querySelectorAll('[data-rebuy-id][data-manual-trigger="subscription"]').forEach((widgetElm) => {
        toggleWidgetVisibility(widgetElm, hasSubscription);
    });

    // Toggle one-time purchase widgets
    document.querySelectorAll('[data-rebuy-id][data-manual-trigger="onetime"]').forEach((widgetElm) => {
        toggleWidgetVisibility(widgetElm, hasOneTime);
    });

    // Toggle ekit-specific widgets
    document.querySelectorAll('[data-rebuy-id][data-manual-trigger="ekit"]').forEach((widgetElm) => {
        toggleWidgetVisibility(widgetElm, hasEkit);
    });
}

/**
 * Toggles the widget's visibility.
 * Uses a timeout to ensure other scripts (if any) don't override the style.
 *
 * @param {HTMLElement} widgetElm - The widget element.
 * @param {boolean} visible - True to show the widget, false to hide.
 */
function toggleWidgetVisibility(widgetElm, visible) {
    if (visible) oneRebuyUpsellWidgetAlreadyShown = true;
    setTimeout(() => {
        widgetElm.classList.toggle('rebuy-manual-trigger-visible', visible);
        const widgetId = widgetElm.getAttribute('data-rebuy-id');
        console.log(`Widget ${widgetId} visibility toggled:`, visible);
    }, 300);
    document.body.classList.toggle('rebuy-modal-visible', visible);
}
